module.exports = __webpack_public_path__ + "img/tablet.693a499b.svg";